import { render, staticRenderFns } from "./RedigirDocumentos.vue?vue&type=template&id=9c323ebc&"
import script from "./RedigirDocumentos.vue?vue&type=script&lang=js&"
export * from "./RedigirDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports